import React from 'react';
import { A11y, Autoplay, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useTheme, useMediaQuery } from '@mui/material';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

const DEFAULT_SLIDE_HEIGHT_MOBILE = 160;
const DEFAULT_SLIDE_HEIGHT_DESKTOP = 172;

interface IProps {
    cards: Array<{ id: number | string; imgUrl?: string; fileName?: string }>;
    slideHeightMobile?: number;
    slideHeightDesktop?: number;
}

const SwiperAuto: React.FC<IProps> = ({
    cards,
    slideHeightMobile = DEFAULT_SLIDE_HEIGHT_MOBILE,
    slideHeightDesktop = DEFAULT_SLIDE_HEIGHT_DESKTOP
}) => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const slideHeight = isDesktop ? slideHeightDesktop : slideHeightMobile;

    const swiperStyle = { height: slideHeight, width: '100%', borderRadius: 24, flexWrap: 'wrap' as const };
    const slideStyle = { height: slideHeight, width: '100%', borderRadius: 24 };
    const imgStyle = { height: slideHeight, width: '100%', objectFit: 'cover' as const };

    return (
        <Swiper
            modules={[Navigation, Pagination, A11y, Autoplay]}
            loop={true}
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            observer={true}
            observeParents={true}
            a11y={{ enabled: true }}
            effect="fade"
            spaceBetween={8}
            slidesPerView={1}
            pagination={{ clickable: true }}
            style={swiperStyle}
        >
            {cards.map((card) => (
                <SwiperSlide key={card.id} style={slideStyle}>
                    <img src={card.imgUrl ?? card.fileName} alt={String(card.id)} style={imgStyle} />
                </SwiperSlide>
            ))}
        </Swiper>
    );
};

export default SwiperAuto;
